<template>
  <div class="social-sharing">
    <div class="label">Share this</div>
    <ul class="share-links">
      <li>
        <a :href="mailtoLink" title="Send an email"
          ><img src="@/assets/icon-social-email.png" class="icon" alt="Email"
        /></a>
      </li>
      <li>
        <a
          :href="facebookLink"
          title="Share on Facebook"
          @click.prevent="createPopupWindow(facebookLink)"
          ><img
            src="@/assets/icon-social-facebook.png"
            class="icon"
            alt="Facebook"
        /></a>
      </li>
      <li>
        <a
          :href="twitterLink"
          title="Share on Twitter"
          @click.prevent="createPopupWindow(twitterLink)"
          ><img
            src="@/assets/icon-social-twitter.png"
            class="icon"
            alt="Twitter"
        /></a>
      </li>
    </ul>
  </div>
</template>

<script>
import createPopupWindow from '@/util/createPopupWindow';
import serializeObject from '@/util/serializeObject';

export default {
  props: {
    fbAppId: {
      type: String,
      default: null,
    },
    shareUrl: {
      type: String,
      default: 'https://covid19hospitalstatus.com',
    },
    tweet: {
      type: String,
      default:
        'Help level demand on our health care system and front-line workers today',
    },
  },
  computed: {
    facebookLink() {
      const params = {};
      let baseUrl = 'https://www.facebook.com/sharer/sharer.php';

      if (this.fbAppId) {
        params.app_id = this.fbAppId;
        params.link = this.shareUrl;
        baseUrl = 'https://www.facebook.com/dialog/feed';
      } else {
        params.u = this.shareUrl;
      }
      return `${baseUrl}?${serializeObject(params)}`;
    },
    mailtoLink() {
      const params = {
        subject:
          'Help level demand on our health care system and front-line workers today',
        body: `Hello, check out: ${this.shareUrl}`,
      };
      return `mailto:?${serializeObject(params)}`;
    },
    twitterLink() {
      const params = {
        text: this.tweet,
        url: this.shareUrl,
      };
      return `https://twitter.com/intent/tweet?${serializeObject(params)}`;
    },
  },
  methods: {
    createPopupWindow,
  },
};
</script>

<style lang="scss" scoped>
.share-links {
  display: flex;
  margin: 0 0 0 auto;
  padding: 0;
  list-style: none;
}

.icon {
  display: block;
  height: 24px;
  margin-left: 8px;
  opacity: 0.5;
  position: relative;
  top: -4px;
  transition: opacity 0.2s ease;
  width: 24px;

  &:hover {
    opacity: 1;
  }
}
</style>
